const agents = typeof window !== 'undefined' ? null : require('./server.js');
export default agents;